import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "../src/assets/css/animate.css";
import "../src/assets/css/custom.css";
import App from "./App";
import { ThemeContextProvider } from "./functions/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeContextProvider>
      <App />
    </ThemeContextProvider>
  </React.StrictMode>
);
